<template>
  <div>
    <v-app-bar color="rgb(255, 190, 0)" class="sombra-barra flex-grow-0 align-center" app>
      <div class="d-flex align-center">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="black--text"></v-app-bar-nav-icon>
        <v-toolbar-title class="black--text">{{ nombreGimnasio }}</v-toolbar-title>
      </div>
      <v-spacer></v-spacer>
      
      <!-- Menú dropdown moderno del usuario -->
      <v-menu offset-y left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            class="user-menu-btn"
          >
            <v-avatar size="32">
              <img :src="fotoPerfilUrl" :alt="nombreUsuario" />
            </v-avatar>
          </v-btn>
        </template>
        
        <v-card class="user-dropdown" min-width="200">
          <!-- Header del menú con info del usuario -->
          <v-card-text class="user-info pa-3">
            <div class="d-flex align-center">
              <v-avatar size="40" class="mr-3">
                <img :src="fotoPerfilUrl" :alt="nombreUsuario" />
              </v-avatar>
              <div>
                <div class="font-weight-medium black--text">{{ nombreUsuario }}</div>
                <div class="caption grey--text">{{ rolFormateado }}</div>
              </div>
            </div>
          </v-card-text>
          
          <v-divider></v-divider>
          
          <!-- Opciones del menú -->
          <v-list dense>
            <v-list-item :to="{ name: 'MiPerfil' }" class="menu-item">
              <v-list-item-icon class="mr-3">
                <v-icon size="20">mdi-account-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Mi Perfil</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
            <v-list-item @click="salir" class="menu-item logout-item">
              <v-list-item-icon class="mr-3">
                <v-icon size="20" color="error">mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="error--text">Cerrar Sesión</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer app v-model="drawer" class="compact-sidebar">
      <!-- Header compacto con perfil de usuario -->
      <div class="profile-header-compact">
        <div class="profile-background-compact"></div>
        <div class="profile-content-compact">
          <v-avatar size="64" class="profile-avatar-compact">
            <img :src="fotoPerfilUrl" :alt="nombreUsuario" />
          </v-avatar>
          <div class="profile-name-compact">{{ nombreUsuario }}</div>
          <div class="profile-role-compact">{{ rolFormateado }}</div>
        </div>
      </div>

      <!-- Navigation Menu Compacta -->
      <v-list class="navigation-menu-compact" dense nav>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="item.link"
          class="nav-item-compact azul-texto"
          active-class="nav-item-active-compact"
        >
          <v-list-item-icon class="nav-item-icon-compact">
            <v-icon class="nav-icon-compact">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="nav-item-title-compact">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import Utiles from '../Servicios/Utiles';
import FotoPerfilService from '../Servicios/FotoPerfilService';
export default {
  name: "Encabezado",

  data: () => ({
    drawer: false,
    nombreUsuario: null,
    nombreGimnasio: null,
    logo: null,
    fotoPerfil: null,
    rolUsuario: null,
    baseItems: [
      { title: "Reportes", icon: "mdi-view-dashboard", link: "/" },
      { title: "Registrar visita", icon: "mdi-home-account", link: "/registrar-visita" },
      { title: "Usuarios", icon: "mdi-account-box", link: "/usuarios" },
      { title: "Miembros", icon: "mdi-weight-lifter", link: "/miembros" },
      { title: "Productos", icon: "mdi-package-variant", link: "/productos" },
      { title: "Ventas", icon: "mdi-cart", link: "/ventas" },
      { title: "Membresías", icon: "mdi-wallet-membership", link: "/membresias" },
      { title: "Pagos", icon: "mdi-account-cash", link: "/pagos" },
      { title: "Visitas", icon: "mdi-calendar-star", link: "/visitas" },
    ],
  }),

  computed: {
    items() {
      const rol = localStorage.getItem('rolUsuario');
      let items = [...this.baseItems];
      if (rol === 'admin') {
        items.splice(1, 0, { title: "Caja", icon: "mdi-cash-register", link: "/caja" });
        return items.filter(item => !item.adminOnly || rol === 'admin');
      } else {
        return [
          { title: "Registrar visita", icon: "mdi-home-account", link: "/registrar-visita" },
          { title: "Miembros", icon: "mdi-weight-lifter", link: "/miembros" },
          { title: "Ventas", icon: "mdi-cart", link: "/ventas" },
          { title: "Membresías", icon: "mdi-wallet-membership", link: "/membresias" },
          { title: "Visitas", icon: "mdi-calendar-star", link: "/visitas" },
        ];
      }
    },
    
    rolFormateado() {
      switch(this.rolUsuario) {
        case 'admin':
          return 'Administrador';
        case 'administrador':
          return 'Administrador';
        case 'usuario':
          return 'Usuario';
        default:
          return this.rolUsuario ? this.rolUsuario.charAt(0).toUpperCase() + this.rolUsuario.slice(1) : 'Usuario';
      }
    },

    fotoPerfilUrl() {
      // Obtener directamente del localStorage
      const idUsuario = localStorage.getItem('idUsuario');
      if (idUsuario) {
        const fotoDirecta = localStorage.getItem(`fotoPerfil_${idUsuario}`);
        
        if (fotoDirecta && fotoDirecta !== 'undefined' && fotoDirecta !== 'null' && fotoDirecta.trim() !== '') {
          // Si es una imagen en base64, devolverla directamente
          if (fotoDirecta.startsWith('data:image/')) {
            return fotoDirecta;
          }
          
          // Si es una ruta de archivo
          if (fotoDirecta.includes('imagenes/')) {
            return this.urlImagen(fotoDirecta);
          }
          
          // Si es solo el nombre del archivo
          return this.urlImagen(`imagenes/${fotoDirecta}`);
        }
      }
      
      // Si no hay foto válida, usar la por defecto
      return this.urlImagen('imagenes/usuario.png');
    }
  },

  watch: {
    // Watcher para detectar cambios en el usuario actual
    '$route'() {
      this.actualizarDatosUsuario();
    }
  },

  mounted(){
    this.actualizarDatosUsuario();
    // Agregar event listener para cambios en localStorage
    window.addEventListener('storage', this.onStorageChange);
    window.addEventListener('userChanged', this.actualizarDatosUsuario);
  },

  beforeDestroy() {
    window.removeEventListener('storage', this.onStorageChange);
    window.removeEventListener('userChanged', this.actualizarDatosUsuario);
  },

  methods:{ 
    async actualizarDatosUsuario() {
      this.nombreUsuario = localStorage.getItem("nombreUsuario");
      this.nombreGimnasio = localStorage.getItem("nombreGimnasio") || 'MasterFit';
      this.logo = localStorage.getItem("logoGimnasio") || 'default-logo.jpg';
      this.rolUsuario = localStorage.getItem("rolUsuario") || 'usuario';
      
      // Obtener la foto del usuario actual
      const idUsuario = localStorage.getItem('idUsuario');
      
      if (idUsuario) {
        const fotoKey = `fotoPerfil_${idUsuario}`;
        let fotoValue = localStorage.getItem(fotoKey);
        
        // Si no hay foto en localStorage, intentar cargar desde la base de datos
        if (!fotoValue || fotoValue === 'null' || fotoValue === 'undefined') {
          try {
            const fotoFromDB = await FotoPerfilService.obtenerFotoPerfil(idUsuario);
            if (fotoFromDB.resultado && fotoFromDB.fotoPerfil) {
              fotoValue = fotoFromDB.fotoPerfil;
              localStorage.setItem(fotoKey, fotoValue);
            }
          } catch (error) {
            console.error('Error al cargar foto desde BD:', error);
          }
        }
        
        // Asignar la foto directamente, sin modificarla
        this.fotoPerfil = fotoValue;
      } else {
        this.fotoPerfil = null;
      }
      
      // Forzar actualización del componente
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    onStorageChange(event) {
      // Detectar cambios en localStorage que afecten al usuario
      if (event.key && (
        event.key === 'nombreUsuario' || 
        event.key === 'idUsuario' || 
        event.key === 'rolUsuario' ||
        event.key.startsWith('fotoPerfil_')
      )) {
        this.actualizarDatosUsuario();
      }
    },

    salir(){
      localStorage.removeItem('logeado')
      localStorage.removeItem('nombreUsuario')
      localStorage.removeItem('idUsuario')
      localStorage.removeItem('rolUsuario')
      // Limpiar todas las fotos de perfil
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('fotoPerfil_')) {
          localStorage.removeItem(key);
        }
      });
      window.location.reload()
    },

    urlImagen(imagen) {
      return Utiles.generarURL(imagen);
    },

    // Método público para actualizar desde otros componentes
    refreshUserData() {
      this.actualizarDatosUsuario();
    }

  }
};
</script>
<style>
.barra-uniforme {
  background-color: #1e1e1e !important;
}

/* Sidebar compacto sin scroll */
.compact-sidebar {
  background-color: #1e1e1e !important;
  overflow-y: hidden !important;
  max-height: 100vh !important;
}

/* Header compacto con perfil */
.profile-header-compact {
  position: relative;
  height: 120px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.profile-background-compact {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(255, 190, 0, 0.2) 0%, rgba(255, 190, 0, 0.1) 50%, rgba(30, 30, 30, 0.9) 100%);
}

.profile-background-compact::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
}

.profile-content-compact {
  position: relative;
  z-index: 2;
  text-align: center;
  color: white;
}

.profile-avatar-compact {
  border: 3px solid rgba(255, 190, 0, 0.6);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  margin-bottom: 8px;
  transition: all 0.3s ease;
}

.profile-avatar-compact:hover {
  border-color: rgba(255, 190, 0, 0.8);
}

.profile-name-compact {
  font-size: 16px;
  font-weight: 600;
  margin: 4px 0 2px 0;
  color: white;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
}

.profile-role-compact {
  font-size: 11px;
  color: rgba(255, 190, 0, 0.9);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

/* Navigation compacta */
.navigation-menu-compact {
  background: transparent !important;
  padding: 0 12px !important;
  max-height: calc(100vh - 155px) !important;
  overflow-y: auto !important;
}

.nav-item-compact {
  position: relative;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
  margin-bottom: 2px;
  border-radius: 8px !important;
  min-height: 40px !important;
}

/* Efecto hover compacto */
.nav-item-compact::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 190, 0, 0.1), transparent);
  transition: left 0.5s ease;
}

.nav-item-compact:hover::before {
  left: 100%;
}

.nav-item-compact:hover {
  background: rgba(255, 190, 0, 0.1) !important;
  box-shadow: 0 2px 8px rgba(255, 190, 0, 0.2);
}

.nav-item-compact:hover .nav-icon-compact {
  color: #ffbe00 !important;
}

.nav-item-compact:hover .nav-item-title-compact {
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* Estado activo compacto */
.nav-item-active-compact {
  background: rgba(255, 190, 0, 0.15) !important;
  border-left: 3px solid #ffbe00 !important;
  box-shadow: 0 2px 6px rgba(255, 190, 0, 0.2);
}

.nav-item-active-compact .nav-icon-compact {
  color: #ffbe00 !important;
}

.nav-item-active-compact .nav-item-title-compact {
  color: #ffbe00 !important;
  font-weight: 600 !important;
}

.nav-item-icon-compact {
  min-width: 40px !important;
  margin-right: 12px !important;
}

.nav-icon-compact {
  color: rgba(255, 255, 255, 0.8) !important;
  font-size: 18px !important;
  transition: all 0.3s ease !important;
}

.nav-item-title-compact {
  color: rgba(255, 255, 255, 0.9) !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  transition: all 0.3s ease !important;
}
.sombra-barra {
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.08) !important;
}

.icono-azul {
  color: white !important;
}
.azul-texto {
  color: white !important;
  font-weight: 600;
}

.active-list-item-yellow {
  background-color: rgb(255, 170, 0) !important; /* Un amarillo más oscuro para el elemento activo */
}

/* Estilos modernos solo para elemento activo */
.nav-item {
  position: relative;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
}

/* Efecto hover moderno */
.nav-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transition: left 0.5s ease;
}

.nav-item:hover::before {
  left: 100%;
}

.nav-item:hover {
  background: rgba(255, 190, 0, 0.1) !important;
  box-shadow: 0 4px 16px rgba(255, 190, 0, 0.2);
  border-radius: 0 20px 20px 0 !important;
}

.nav-item:hover .nav-item-icon .v-icon {
  color: #ffbe00 !important;
  filter: drop-shadow(0 0 8px rgba(255, 190, 0, 0.4));
}

.nav-item:hover .nav-item-title {
  color: #ffffff !important;
  font-weight: 600 !important;
}

.nav-item-active-modern {
  background: linear-gradient(90deg, rgba(255, 190, 0, 0.15) 0%, rgba(255, 190, 0, 0.05) 100%) !important;
  border-radius: 0 25px 25px 0 !important;
  margin-right: 8px !important;
  border-left: 4px solid #ffbe00 !important;
  box-shadow: 0 2px 8px rgba(255, 190, 0, 0.2);
}

.nav-item-active-modern .nav-item-icon .v-icon {
  color: #ffbe00 !important;
}

.nav-item-active-modern .nav-item-title {
  color: #ffbe00 !important;
  font-weight: 600 !important;
}

.nav-active-indicator {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  background: #ffbe00;
  border-radius: 50%;
  opacity: 0;
  transition: all 0.3s ease;
}

.nav-item-active-modern .nav-active-indicator {
  opacity: 1;
  box-shadow: 0 0 8px rgba(255, 190, 0, 0.6);
  animation: activeGlow 2s infinite;
}

@keyframes activeGlow {
  0%, 100% { 
    box-shadow: 0 0 8px rgba(255, 190, 0, 0.6);
  }
  50% { 
    box-shadow: 0 0 12px rgba(255, 190, 0, 0.8);
  }
}

.black-logo {
  filter: brightness(0) invert(0); /* Esto intentará hacer que el logo sea negro si es blanco */
}

/* Avatar en la barra superior */
.user-menu-btn {
  transition: all 0.3s ease !important;
}

.user-menu-btn:hover {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.user-menu-btn .v-avatar {
  border: 2px solid rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.user-menu-btn:hover .v-avatar {
  border-color: rgba(0, 0, 0, 0.3);
}

/* Dropdown del usuario */
.user-dropdown {
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  overflow: hidden !important;
}

.user-info {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.user-info .v-avatar {
  border: 2px solid rgba(255, 190, 0, 0.3);
}

.menu-item {
  transition: all 0.2s ease !important;
  margin: 2px 8px !important;
  border-radius: 8px !important;
  min-height: 44px !important;
}

.menu-item:hover {
  background-color: rgba(255, 190, 0, 0.1) !important;
}

.logout-item:hover {
  background-color: rgba(244, 67, 54, 0.05) !important;
}

.menu-item .v-list-item-icon {
  min-width: auto !important;
}

/* Animación de entrada del dropdown */
.v-menu__content {
  animation: dropdownFadeIn 0.3s ease-out;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Estilo para ocultar el texto de los elementos de lista en la barra lateral */
/* Removido para mostrar texto */
/* .v-list-item.azul-texto .v-list-item-content {
  display: none; /* Oculta el contenido del texto */
/* } */
</style>



// WEBPACK FOOTER //
// src/components/Encabezado.vue